import { render, staticRenderFns } from "./PriceListTable.vue?vue&type=template&id=05123e2e&scoped=true&"
import script from "./PriceListTable.vue?vue&type=script&lang=js&"
export * from "./PriceListTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceListTable.vue?vue&type=style&index=0&id=05123e2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05123e2e",
  null
  
)

export default component.exports